import { render, staticRenderFns } from "./DropzoneImageUploader.vue?vue&type=template&id=da5faa74&scoped=true"
import script from "./DropzoneImageUploader.vue?vue&type=script&lang=js"
export * from "./DropzoneImageUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5faa74",
  null
  
)

export default component.exports